import { Chip } from '@circlefin/components'
import { TransactionStatus } from '@shared/graphql'
import useTranslation from 'next-translate/useTranslation'

import type { ChipProps } from '@circlefin/components/lib/Chip'

const chipVariants: Record<TransactionStatus, ChipProps['variant']> = {
  [TransactionStatus.complete]: 'status/neutral',
  [TransactionStatus.pending]: 'status/neutral',
  [TransactionStatus.incomplete]: 'status/warning',
  [TransactionStatus.failed]: 'status/error',
}

export interface TransactionStatusChipProps extends Omit<ChipProps, 'variant'> {
  /**
   * Transaction status.
   */
  status: TransactionStatus
}

export const TransactionStatusChip: React.FC<TransactionStatusChipProps> = ({
  status,
  ...rest
}) => {
  const { t } = useTranslation('common')

  return (
    <Chip
      data-testid="transaction-status-chip"
      variant={chipVariants[status]}
      {...rest}
    >
      {t(`transaction.statusLabels.${status}`)}
    </Chip>
  )
}
